// eslint-disable-next-line import/no-extraneous-dependencies
import { UAParser } from 'ua-parser-js';

export enum DeviceType {
  mobile,
  tablet,
  desktop
}

export interface Device {
  vendor: string | null;
  model: string | null;
}

export const getDeviceType = (
  userAgent: string
): {
  deviceType: DeviceType;
  device: Device;
} => {
  if (!userAgent) {
    return {
      deviceType: DeviceType.desktop,
      device: { vendor: null, model: null }
    };
  }

  const parser = new UAParser(userAgent);
  const rawDevice = parser.getDevice();

  const device = {
    vendor: rawDevice?.vendor ?? null,
    model: rawDevice?.model ?? null
  };

  switch (rawDevice.type) {
    case 'mobile':
      return { deviceType: DeviceType.mobile, device };
    case 'tablet':
      return { deviceType: DeviceType.tablet, device };
    default:
      return { deviceType: DeviceType.desktop, device };
  }
};

export const checkIsIphone = (device: Device): boolean => {
  return device?.vendor === 'Apple' && device?.model === 'iPhone';
};
